import alertsDomain from './alerts.domain';
/* eslint-disable import/prefer-default-export */
export const domain = alertsDomain;
